import { Service } from "typedi";
import { DeviceInformationDTO } from "../../../../../schools-backend/src/student/application/dtos/DeviceInformationDTO";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";

/**
 * v1: browser-context info only. Serial/hardware fields require enterprise
 * APIs we do not have. Best-effort `userAgent` decomposition.
 */
@Service()
export class GetDeviceInformation implements AgentRPCCommand<"get.device.information"> {
    constructor(agentRPCCommands: AgentRPCCommands) {
        agentRPCCommands.register("get.device.information", this);
    }

    async run(): Promise<DeviceInformationDTO | null> {
        const platform = (navigator as unknown as { platform?: string }).platform ?? "unknown";
        return {
            manufacturer: platform,
            model: navigator.userAgent,
            serialNumber: ""
        };
    }
}
